import React, { useState } from 'react';
import { Box, Tab, Tabs, Typography } from '@mui/material';
import DoorDelivery from '../../components/checkout/DoorDelivery.jsx';
import HealthcareCenter from '../../components/checkout/HealthcareCenter.jsx';
import NearestPharmacy from '../../components/checkout/NearestPharmacy.jsx';
import { APIProvider } from '@vis.gl/react-google-maps';

const libraries = ['places'];

function CustomerAddress ({ onUpdateDeliveryMethod }) {
  const [value, setValue] = useState(0);
  const API_KEY = process.env.GOOGLE_MAPS_API_KEY;

  const handleUpdateDeliveryDetails = (deliveryDetails) => {
    // Process delivery details and potentially pass them up to parent
    console.log('Delivery details updated:', deliveryDetails);
    // If you need to send this to a parent component:
    if (onUpdateDeliveryMethod) {
      onUpdateDeliveryMethod(deliveryDetails);
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <APIProvider apiKey={API_KEY} libraries={libraries}>
      <Box
        sx={{
				  width: '100%',
				  typography: 'body1',
				  backgroundColor: '#1e1e1e',
				  color: 'white'
        }}
      >
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Typography variant='h3' mb='1rem'>
            Customer Address
          </Typography>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label='customer address tabs'
            variant='fullWidth'
            sx={{ backgroundColor: '#333', color: 'white' }}
          >
            <Tab label='Door Delivery' sx={{ color: 'white' }} />
            <Tab label='Nearest Healthcare Center' sx={{ color: 'white' }} />
            <Tab label='Nearest Pharmacy' sx={{ color: 'white' }} />
          </Tabs>
        </Box>
        <Box hidden={value !== 0}>
          <DoorDelivery onUpdateDeliveryDetails={handleUpdateDeliveryDetails} />
        </Box>
        <Box hidden={value !== 1}>
          <HealthcareCenter
            onUpdateDeliveryDetails={handleUpdateDeliveryDetails}
          />
        </Box>
        <Box hidden={value !== 2}>
          <NearestPharmacy
            onUpdateDeliveryDetails={handleUpdateDeliveryDetails}
          />
        </Box>
      </Box>
    </APIProvider>
  );
}

export default CustomerAddress;
